"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MapSourceModule = require("../../MapSourceModule");

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var colors = {
  TURB: '#e98e00',
  ICE: '#2452e9',
  CONVECTIVE: '#e90000',
  TS: '#ffe300'
};

var getColor = function (code) {
  code = (code || 'none').toUpperCase();
  return colors[code] || '#999999';
};

var Sigmets =
/** @class */
function (_super) {
  __extends(Sigmets, _super);

  function Sigmets() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Sigmets.prototype, "id", {
    get: function () {
      return this.opts.id || 'aviation-sigmets';
    },
    enumerable: false,
    configurable: true
  });

  Sigmets.prototype.source = function () {
    return {
      type: 'geojson',
      data: {
        url: '//uat.aerisweather.com/demos/data/sigmet.json',
        properties: {
          id: 'icaoId',
          category: 'hazard'
        }
      },
      style: {
        polygon: function (item) {
          return {
            fill: {
              color: getColor(item.hazard),
              opacity: 0.4
            },
            stroke: {
              color: getColor(item.hazard),
              width: 2
            }
          };
        }
      }
    };
  };

  Sigmets.prototype.controls = function () {
    return {
      value: this.id,
      title: 'SIGMETs'
    };
  };

  Sigmets.prototype.legend = function () {
    return null;
  };

  Sigmets.prototype.infopanel = function () {
    return {
      view: {
        views: [{
          data: function (data) {
            return data.sigmet;
          },
          renderer: function (data) {
            if (!data) return null;
            return "<div class=\"sigmet\">" + (data.rawAirSigmet || '').replace(/\n/g, '<br>') + "</div>";
          }
        }]
      }
    };
  };

  Sigmets.prototype.onShapeClick = function (shape, data) {
    data = data || {}; // this.app.showInfo('sigmet', `${props.icaoId} - ${utils.strings.toName(props.hazard)} SIGMET`, { sigmet: props });

    this.showInfoPanel(data.icaoId + " - " + data.hazard + " SIGMET", {
      sigmet: data
    });
  };

  return Sigmets;
}(_MapSourceModule.BaseMapSourceModule);

var _default = Sigmets;
exports.default = _default;
module.exports = exports.default;